module.exports = __webpack_public_path__ + "img/8.66f686d9.webp";